var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.toast.show)?_c('div',{staticClass:"toast"},[_c('p',{staticClass:"toast-main"},[_vm._v(_vm._s(_vm.toast.text))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }